import Model from './Model'

export default class CompanyUserModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'companyUsers'
  }
}
